import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import { History } from 'history';
import companySubscriptionPlanReducer from './SubscriptionPlan/SubscriptionPlanSlice';
import PIOfferingBoardSlice from './PIOfferingBoard/PIOfferingBoardSlice';

export default function createRootReducer(history: History) {
  return combineReducers({
    router: connectRouter(history),
    companySubscriptionPlan: companySubscriptionPlanReducer,
    pIOfferingBoard: PIOfferingBoardSlice,
  });
}
